import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function MeetingBooking() {
    return (
        <OnboardingBody title='Scheduler: Your meeting booking companion'>
            <p>
                Say goodbye to endless email chains and embrace the simplicity of scheduling right
                within your CRM.
            </p>
            <p>
                Scheduler integrates with your Google or Microsoft 365 calendar to seamlessly
                coordinate meeting bookings. Connect to Zoom, Google Meet, or Microsoft Teams to
                automatically create virtual meeting links.
            </p>
        </OnboardingBody>
    );
}
